import * as React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Breadcrumbs, { breadcrumbsClasses } from '@mui/material/Breadcrumbs';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import { Params, UIMatch, useLocation, useMatches, useParams } from 'react-router-dom';

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
    margin: theme.spacing(1, 0),
    [`& .${breadcrumbsClasses.separator}`]: {
        color: (theme.vars || theme).palette.action.disabled,
        margin: 1,
    },
    [`& .${breadcrumbsClasses.ol}`]: {
        alignItems: 'center',
    },
}));

export default function NavbarBreadcrumbs() {
    const location = useLocation();
    const matches = useMatches() as UIMatch<unknown, { crumb: (params: Readonly<Params<string>>) => JSX.Element }>[];
    const paths = React.useMemo(() => {
        return location.pathname.split('/').filter(d => d);
    }, [location])
    const params = useParams();
    return (
        <StyledBreadcrumbs
            aria-label="breadcrumb"
            separator={<NavigateNextRoundedIcon fontSize="small" />}
        >
            <Typography variant="body1">Dashboard</Typography>
            {paths.length === 0 && <Typography variant="body1" sx={{ color: 'text.primary', fontWeight: 600 }}>
                Ana Sayfa
            </Typography>}
            {matches.filter(m => !!m.handle?.crumb).map((m, i) => <div key={i}>{m.handle.crumb(params)} </div>)}
        </StyledBreadcrumbs>
    );
}